// eslint-disable-next-line no-unused-vars
var $ = jQuery.noConflict();
